import React from 'react';

const styles = {
  wrap: {
    marginTop: 4,
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-md)',
    background: 'var(--bg-card)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '10px 14px',
    borderBottom: '1px solid var(--border)',
    background: 'var(--bg-hover)',
  },
  title: {
    fontFamily: 'var(--font-mono)',
    fontSize: 11,
    color: 'var(--text-secondary)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: 1,
  },
  formatBadge: {
    fontFamily: 'var(--font-mono)',
    fontSize: 10,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'var(--brand)',
    border: '1px solid var(--brand-border)',
    background: 'var(--brand-dim)',
    padding: '2px 8px',
    borderRadius: 100,
    flexShrink: 0,
  },
  openLink: {
    fontFamily: 'var(--font-mono)',
    fontSize: 11,
    color: 'var(--brand)',
    textDecoration: 'none',
    flexShrink: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
  },
  frameWrap: {
    position: 'relative',
    height: 'min(72vh, 640px)',
    minHeight: 320,
    background: 'var(--bg-hover)',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
  },
  loading: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'var(--font-mono)',
    fontSize: 12,
    color: 'var(--text-tertiary)',
    background: 'var(--bg-card)',
  },
  empty: {
    padding: '48px 24px',
    textAlign: 'center',
    fontFamily: 'var(--font-mono)',
    fontSize: 12,
    color: 'var(--text-tertiary)',
    lineHeight: 1.6,
  },
};

export default function PdfPreviewPanel({ url, loading, title, formatLabel, onOpenNewTab }) {
  return (
    <div style={styles.wrap} id="review-preview-panel">
      <div style={styles.header}>
        <span style={styles.title} title={title || undefined}>
          {title || 'Processed PDF'}
        </span>
        {formatLabel ? <span style={styles.formatBadge}>{formatLabel}</span> : null}
        {url && onOpenNewTab ? (
          <button type="button" style={styles.openLink} onClick={onOpenNewTab}>
            Open in tab ↗
          </button>
        ) : null}
      </div>
      <div style={styles.frameWrap}>
        {loading ? (
          <div style={styles.loading}>Loading preview…</div>
        ) : url ? (
          <embed
            type="application/pdf"
            title={title ? `PDF preview: ${title}` : 'PDF preview'}
            src={`${url}#toolbar=1&navpanes=0`}
            style={styles.iframe}
          />
        ) : (
          <div style={styles.empty}>
            Select the <strong>PDF preview</strong> tab to load the generated document.
          </div>
        )}
      </div>
    </div>
  );
}

